<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Daftar Responden</h5>
              <!-- <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
										v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>-->
            </div>

            <div class="card p-3 shadow-sm">
              <!-- <h5 class="mb-3">Filter Data</h5> -->
              <form @submit.prevent="getDataList" id="filterForm" class="row g-3 align-items-end">
                <!-- Kolom 1 -->
                <div class="col-md-3 offset-4">
                  <!-- <label for="filterNama" class="form-label">Nama</label> -->
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control"
                    id="filterNama"
                    placeholder="Pencarian nama"
                  >
                </div>

                <div class="col-md-3">
                  <!-- <label for="filterNik" class="form-label">NIK</label> -->
                  <input
                    v-model="cariNik"
                    type="text"
                    class="form-control"
                    id="filterNik"
                    placeholder="Pencarian NIK"
                  >
                </div>

                <!-- Kolom 2 -->
                <!-- <div class="col-md-3">
      <label for="filterTanggal" class="form-label">Tanggal</label>
      <input type="date" class="form-control" id="filterTanggal">
                </div>-->

                <!-- Kolom 3 -->
                <!-- <div class="col-md-3">
      <label for="filterStatus" class="form-label">Status</label>
      <select id="filterStatus" class="form-select">
        <option value="">-- Pilih Status --</option>
        <option value="aktif">Aktif</option>
        <option value="nonaktif">Nonaktif</option>
      </select>
                </div>-->

                <!-- Tombol -->
                <div class="col-2 d-flex justify-content-end gap-2 mt-0">
                  <button type="button" class="btn btn-secondary" @click="resetFilter" id="btnReset">Reset</button>
                  <button type="submit" class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Nama Lengkap
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th scope="col">
                      <a href="#" class="link-dark">
                        NIK
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th scope="col">Alamat</th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tanggal Daftar
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="req.id">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td class="text-nowrap">{{ safeGet(req, 'user_profile.fullname') }}</td>
                    <td>{{ displayValue(safeGet(req, 'user_profile.nik')) }}</td>
                    <td class="text-nowrap">
                      <div>{{ displayValue(safeGet(req, 'user_profile.address', ' ')) }} - {{ displayValue(safeGet(req, 'user_profile.city', ' ')) }}</div>
                      <div
                        class="small text-dark"
                      >{{ displayValue(safeGet(req, 'user_profile.province', ' ')) }} - {{ displayValue(safeGet(req, 'user_profile.postal_code', ' ')) }}</div>
                    </td>
                    <td class="text-center">{{ formatDate(req.createdAt) }}</td>

                    <td class="text-center">
                      <small
                        :class="req.statusId == 1 ? 'text-bg-success' : 'text-bg-danger'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ safeGet(req, 'site_status.status_name') }}</small>
                    </td>
                    <td class="text-nowrap text-end">
                      <router-link
                        :to="`/report?userId=${req.id}`"
                        class="btn btn-sm btn-outline-danger me-1"
                        title="Report"
                      >
                        <i class="ti ti-report-analytics fs-3"></i>
                      </router-link>
                      <router-link
                        :to="`/user-assessment?userId=${req.id}`"
                        class="btn btn-sm btn-outline-warning me-1"
                        title="Assessment"
                      >
                        <i class="ti ti-list-check fs-3"></i>
                      </router-link>
                      <router-link
                        :to="`/user-examination?userId=${req.id}`"
                        class="btn btn-sm btn-outline-success me-1"
                        title="Diagnosa"
                      >
                        <i class="ti ti-clipboard-check fs-3"></i>
                      </router-link>
                      <router-link
                        :to="`/form-responden?type=responden&userId=${req.id}`"
                        class="btn btn-sm btn-outline-primary"
                        title="Detail"
                      >
                        <i class="ti ti-user fs-3"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			cariTitle: '',
			cariNik: '',
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50]
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation'
		})
	},
	methods: {
    resetFilter(){
      this.cariTitle = ''
      this.cariNik = ''
    },
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			// if (from == "date_start" && this.filter.date_end == "") {
			//   return
			// }
			// if (from == "aging") {
			//   if (this.filter.aging) this.filter.bill_status = "Unpaid";
			// } else if (from == "status") {
			//   if (this.filter.bill_status == "Paid") this.filter.aging = "";
			// }
			// var ds = new Date(this.filter.date_start);
			// var de = new Date(this.filter.date_end);
			this.$store
				.dispatch('location/getData', {
					url: `users`,
					params: {
						fullname: this.cariTitle,
						nik: this.cariNik,
						type: 'patient',
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
						// status: this.status,
						// search: this.search,
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
					// this.loaded = true;
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		}
	}
}
</script>
